export default __webpack_public_path__ + "static/media/empty-chart.03a3764f.svg";